import { ActionIcon, CopyButton } from '@mantine/core';
import { IconCopy, IconCopyCheck } from '@tabler/icons-react';
import type { ComponentProps } from 'react';

type CopyToClipboardProps = ComponentProps<typeof ActionIcon> & {
  text: string;
};

export const CopyToClipboard = ({ text, ...rest }: CopyToClipboardProps) => {
  return (
    <CopyButton value={text}>
      {({ copied: isCopied, copy }) => (
        <ActionIcon variant="transparent" onClick={copy} {...rest}>
          {isCopied ? <IconCopyCheck size={18} /> : <IconCopy size={18} />}
        </ActionIcon>
      )}
    </CopyButton>
  );
};
